import trackEvent from '../trackEvent';

type Args = { event: string; errors: GenericErrorType[] };

const sendFormErrorGtm = ({ event, errors }: Args) => {
  const items = errors.map(({ params, message }) => ({
    field: params?.[0]?.value || 'general',
    msg: message,
  }));
  trackEvent(
    {
      failReason: JSON.stringify({ items }),
    },
    event,
  );
};

export default sendFormErrorGtm;
